import React from 'react'
import PropTypes from 'prop-types'

import './style.css.scss'
class DynamicTextarea extends React.Component {
  componentDidMount() {
    this.handleResize()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value != this.props.value) {
      this.handleResize()
    }
  }

  resize() {
    this.style.height = 'auto'
    this.style.height = `${this.scrollHeight}px`
  }

  handleResize = () => {
    this.resize.apply(this.dynamicTextarea)
  }

  handleTextareaChange = (e) => {
    this.props.onChange(e.target.value)
  }

  render() {
    return (
      <textarea
        className='dynamic-textarea'
        ref={ref => this.dynamicTextarea = ref }
        value={this.props.value}
        placeholder='Add a Title'
        onChange={this.handleTextareaChange}
        rows="1"
        disabled={this.props.readOnly} />
    )
  }
}

DynamicTextarea.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
}

DynamicTextarea.defaultProps = {
  value: ''
}

export default DynamicTextarea